module.exports = __webpack_public_path__ + "17171ae64debfad321dc1bf821292510.svg";